import React, { useState, useEffect } from "react";
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { getPatientsList, getTemplateList, AddNewCompose } from "../../../store/compose/actions";

import MessagePopup from "../../../components/admin/compose/message-popup";
import { ComposeDropDownOption } from "../../../components/admin/compose/compose-dropdown-option";
import { ComposeDropDownMessage } from "../../../components/admin/compose/compose-dropdown-message"
import { ComposeDropDownBtn } from "../../../components/admin/compose/compose-dropdown-btn"
import ComposeSelectGroups from "../../../components/admin/compose/compose-select-groups";
import ComposeOneTimeGroup from "../../../components/admin/compose/compose-one-time-group";


const defualtComposeObj = {
    id: 0,
    templateid: null,
    content: '',
    spanishContent:'',
    datesent: new Date(),
    composepatients: [],
    composegroups: [],
    composeonetimegroups:[]
};

const composeManually = "Composed - Custom";
const composeManuallyId = 5;

const generalTemplate = "Composed - General Template";
const generalTemplateId = 4;

export default function Compose() {
    const dispatch = useDispatch();
    
    const { searchPatients, templateList } = useSelector((state) => state.compose);
    const { groupList } = useSelector((state) => state.grouplists);
    const [selectedOption, setSelectedOption] = useState([]);
    const [selectedMessages, setSelectedMessages] = useState(null);
    const [fullMessage, setFullMessage] = useState(false);
    const [isReadOnlyfullMessage, setIsReadOnlyfullMessage] = useState(false);
    const [showMessagePopupModal, setShowMessagePopupModal] = useState(false);
    const [showGroupsSelectModal, setShowGroupsSelectModal] = useState(false);
    const [showOneTimeGroupModal, setShowOneTimeGroupModal] = useState(false);
    const [composeModel, setComposeModel] = useState(defualtComposeObj);
    const [composeToCount, setComposeToCount] = useState(0);
    const [toErrorMessage, setToErrorMessage] = useState(null);
    const [messageTempErrorMessage, setMessageTempErrorMessage] = useState(null);
    const [errorFullMessage, setErrorFullMessage] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);


    useEffect(() => {
        dispatch(getTemplateList());
    }, []); 

    useEffect(() => {
        if (selectedOption !== null) {
            const itemCount = selectedOption.reduce((count, item) => {
                return count + (item.recordCount === undefined || item.recordCount === null ? 1 : item.recordCount);
            }, 0);
            setComposeToCount(itemCount);
        }
    }, [selectedOption]);    


    const getOptionValue = option => option.name !== undefined && option.name !== null ? option.name : option.patientPhoneNumber.toString();
    const getOptionLabel = option => {
        if (option.isNewCreateGroup) {
            return `${option.name}`;
        }
        else if (option.name !== undefined && option.name !== null) {
            return `${option.name} (${option.recordCount})`;
        } else {
            return `${option.firstName} ${option.lastName}`;
        }   
    }
    const noOptionsMessage = () => null;

    const getMessageValue = option => option.id.toString();
    const getMessageLabel = option => option.name;


    const handleChange = (selectedItem) => {
        setSelectedOption(selectedItem); 
        const composeToPatients = selectedItem.filter(item => item.recordCount === undefined || item.recordCount === null).map((item) => item.id);
        const composeToGropup = selectedItem.filter(item => item.recordCount !== undefined && item.recordCount !== null && item.isNewCreateGroup === undefined).map((item) => item.id);
        const composeToCreateGropup = selectedItem.filter(item => item.isNewCreateGroup).map((item) => item.group);
        setComposeModel({
            ...composeModel,
            composepatients: composeToPatients,
            composegroups: composeToGropup,
            composeonetimegroups: composeToCreateGropup
        });

        setToErrorMessage(null);
    };

    const handleMessagesChange = (selectedItem) => {
        setSelectedMessages(selectedItem);
        
        if (selectedItem?.messageType?.name === composeManually || selectedItem.messageTypeId === composeManuallyId) { 
            setFullMessage(true);
        } else {
            setFullMessage(false);
        }

        if (selectedItem?.messageType?.name === generalTemplate || selectedItem.messageTypeId === generalTemplateId) {
            setIsReadOnlyfullMessage(true);
        } else {
            setIsReadOnlyfullMessage(false);
        }        

        setComposeModel({ ...composeModel, templateid: selectedItem.id, content: selectedItem.englishContent, spanishContent: selectedItem.spanishContent });
        setMessageTempErrorMessage(null);
    };

    const handleSendPopup = () => {
        let errors = false;
        if (selectedOption.length === 0) {
            setToErrorMessage('To field is required.');
            errors = true;
        }

        if (composeModel.templateid === null || composeModel.templateid === 0) {
            setMessageTempErrorMessage('Message field is required.');
            errors = true;
        }

        const temp = templateList.find(item => item.id === composeModel.templateid);
        if (temp && temp.messageTypeId === composeManuallyId && (composeModel.content === null || composeModel.content === '')) {
            setErrorFullMessage('Full message field is required.');
            errors = true;
        }

        if (errors) {
            return;
        }

        if (composeModel.composepatients.length > 0 || composeModel.composegroups.length > 0 || composeModel.composeonetimegroups.length > 0) {
            selectedOption && selectedOption.length > 0 && setShowMessagePopupModal(true);
        }
    };

    const handleSendCompose = () => {
        dispatch(AddNewCompose(composeModel))
    }

    const handleSelectComposeGroups = (selectedGroups) => {
        const composeToGroups = selectedGroups.filter(item => item.isNewCreateGroup === undefined || item.isNewCreateGroup === false).map((item) => item.id);
        if (selectedOption === null) {
            setSelectedOption(selectedGroups);
        } else {
            const updatedOptions = selectedOption.filter(item => item.name === null || item.name === undefined);
            setSelectedOption(updatedOptions.concat(selectedGroups));
        }
        setComposeModel({ ...composeModel, composegroups: composeToGroups });
        setShowGroupsSelectModal(false);
        setToErrorMessage(null);
    }

    const handleOneTimeGroups = (createdGroup, countPeople) => {       
        const minId = groupList.reduce((max, obj) => (obj.id > max ? obj.id : max), 0);
        const createdGroupName = {
            id: Math.floor(Math.random() * 1000) + minId,
            name: countPeople === 1 ? '1 Person' : `${countPeople} People`,
            recordCount: countPeople,
            isNewCreateGroup: true,
            group: createdGroup
        };
        setSelectedOption(prevState => [...prevState, createdGroupName]);
        setComposeModel({
            ...composeModel,
            composeonetimegroups: [...composeModel.composeonetimegroups, createdGroup]
        });
        setToErrorMessage(null);
    }

    const handleComposeBtnClick = () => {
        const manually = templateList.find(x => x.messageTypeId === composeManuallyId);
        handleMessagesChange(manually);
        setIsDropdownOpen(false);
    };


    const handleMenuOpen = () => {
        setIsDropdownOpen(true);        
    };

    const handleMenuClose = () => {
        setIsDropdownOpen(false);        
    };



    return (
        
        <div className="admin-page-wrap compose-page-wrapper">           
            <div className="pageContainer">
                <div className="admin-page-content">
                    <div className="admin-page-title-wrap">
                        <h1 className="admin-page-heading">Compose</h1>
                    </div>
                    <MessagePopup
                        show={showMessagePopupModal}
                        onClose={() => setShowMessagePopupModal(false)}
                        handleConfirmation={handleSendCompose}
                        message={`Are you sure you want to send to ${composeToCount !== 0 && composeToCount} ${composeToCount ===1 ? 'person': 'people'}?`}
                    />
                    <ComposeSelectGroups
                        show={showGroupsSelectModal}
                        onClose={() => setShowGroupsSelectModal(false)}
                        handleAddGroups={handleSelectComposeGroups}
                        selectedItem={selectedOption && selectedOption.filter(item => item.name !== null && item.name !== undefined) }
                    />
                    <ComposeOneTimeGroup
                        show={showOneTimeGroupModal}
                        onClose={() => setShowOneTimeGroupModal(false)}
                        handleCreateGroup={handleOneTimeGroups}
                    />
                    <div>
                        <label htmlFor="compose-to" className="admin-default-label">To</label>
                        <div className="admin-section-row">
                            <div className="admin-section-cell wide multi-compose-select-wrapper">                                
                                <Select                                    
                                    className="multi-compose-select"
                                    value={selectedOption}
                                    onChange={handleChange}
                                    options={searchPatients}
                                    getOptionValue={getOptionValue}
                                    getOptionLabel={getOptionLabel}
                                    isMulti
                                    components={{ Option: ComposeDropDownOption, DropdownIndicator: null }}
                                    onInputChange={(newValue) => { newValue && dispatch(getPatientsList({ data: newValue })) }}
                                    placeholder=""
                                    noOptionsMessage={noOptionsMessage}
                                    id="compose-to" 
                                />
                            </div>  
                            <div className="admin-section-cell wide">
                                <div className="admin-bottom-bar-left">
                                    <button className="admin-button create-outline-btn compose-group-btn" onClick={() => setShowGroupsSelectModal(true)}>
                                        <span>Group</span>
                                        <span className="material-symbols-rounded">add</span>
                                    </button>
                                    <button className="admin-button create-outline-btn compose-group-btn" onClick={() => setShowOneTimeGroupModal(true)}>
                                        <span>One-Time Group</span>
                                        <span className="material-symbols-rounded">add</span>
                                    </button>                                    
                                </div>                                
                            </div>
                        </div>
                        {toErrorMessage && <p className="error-messagess">{toErrorMessage}</p>}
                        <div className="admin-section-row compose-mesage-row ">
                            <div className="admin-section-cell wide compose-message-wide ">
                                <label htmlFor="message" className="admin-default-label">Message</label>
                                <Select                         
                                    className="compose-message-type"
                                    value={selectedMessages}
                                    onChange={handleMessagesChange}
                                    options={templateList.filter(x => x.messageTypeId !== composeManuallyId)}
                                    getOptionValue={getMessageValue}
                                    getOptionLabel={getMessageLabel}
                                    placeholder=""
                                    id="message"
                                    menuIsOpen={isDropdownOpen}
                                    onMenuOpen={handleMenuOpen}
                                    onMenuClose={handleMenuClose}
                                    isSearchable={false}
                                    components={{ Option: ComposeDropDownMessage, Menu: props => <ComposeDropDownBtn {...props} onClick={handleComposeBtnClick} /> }}                   
                                />
                                {messageTempErrorMessage && <p className="error-messagess">{messageTempErrorMessage}</p>}                                
                            </div>                           
                        </div>
                        {fullMessage && <div className="admin-section-row">
                            <div className="admin-section-cell wide compose-message-wide">
                                <label htmlFor="full-message" className="admin-default-label">Full Message</label>
                                <textarea
                                    className="admin-default-textarea compose-message-textarea"
                                    id="full-message"
                                    onChange={e => {
                                        setComposeModel({ ...composeModel, content: e.target.value });
                                        if (e.target.value != '') {
                                            setErrorFullMessage(null);
                                        }                                        
                                    }}
                                />
                                {errorFullMessage && <p className="error-messagess">{errorFullMessage}</p>}
                            </div>
                        </div> }
                        {isReadOnlyfullMessage && <div className="admin-section-row">
                            <div className="admin-section-cell wide compose-message-wide">
                                <label htmlFor="full-message" className="admin-default-label">Full Message</label>
                                <textarea
                                    className="admin-default-textarea compose-message-textarea"
                                    id="full-message"
                                    value={composeModel.content}
                                    readOnly
                                />
                            </div>
                        </div>}

                        {isReadOnlyfullMessage && composeModel.spanishContent && composeModel.spanishContent.trim() !== '' && <div className="admin-section-row">
                            <div className="admin-section-cell wide compose-message-wide">
                                <label htmlFor="full-message" className="admin-default-label">Full Message (Spanish)</label>
                                <textarea
                                    className="admin-default-textarea compose-message-textarea"
                                    id="full-message"
                                    value={composeModel.spanishContent}
                                    readOnly
                                />
                            </div>
                        </div>}
                        <div className="admin-section-row send-button-wrapper">
                            <div className="admin-section-cell wide button-align-right compose-message-wide">                                
                                <button className="admin-button send-mail" onClick={handleSendPopup}>Send {composeToCount !== 0 ? composeToCount === 1 ? 'to 1 Person' : `to ${composeToCount} People` : null}</button>
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
    );
}